import * as THREE from 'three';

const equatorialRadius = 6.378137e6;
const flatteningFactor = 3.35281066474748e-3;
const eccentricitySquared = flatteningFactor * (2 - flatteningFactor);

export type Place = {
  lat: number;
  long: number;
  alt: number;
};

export const locationToEcef = (loc: Place): THREE.Vector3 => {
  const latRad = loc.lat * (Math.PI / 180);
  const longRad = loc.long * (Math.PI / 180);

  const N =
    equatorialRadius /
    Math.sqrt(1 - eccentricitySquared * Math.sin(latRad) * Math.sin(latRad));

  const x = (N + loc.alt) * Math.cos(latRad) * Math.cos(longRad);
  const y = (N + loc.alt) * Math.cos(latRad) * Math.sin(longRad);
  const z = (N * (1 - eccentricitySquared) + loc.alt) * Math.sin(latRad);

  return new THREE.Vector3(x, y, z);
};

export const locationToArea = (loc: Place, radius: number): THREE.Sphere => {
  const center = locationToEcef(loc);
  return new THREE.Sphere(center, radius);
};

export const locationToSurfaceRotation = (loc: Place): THREE.Quaternion => {
  const ecef = locationToEcef({ lat: loc.lat, long: loc.long, alt: 0 });
  const up = new THREE.Vector3(ecef.x, ecef.z, -ecef.y).normalize();
  const targetUp = new THREE.Vector3(0, 1, 0);
  const quat = new THREE.Quaternion().setFromUnitVectors(up, targetUp);

  return quat.normalize();
};
